import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Breakpoint } from '@app-enums'
import { HeaderTheme, setHeaderDisplay, setHeaderTheme } from '@app-components'
import { autoSearch, phoneStatementSlider } from '@app-services'

autoSearch()

// ------------------------------------------------------------------------------
//      Navigation theme handling
// ------------------------------------------------------------------------------

{
    const heroContainer = document.getElementById('brand-hero')!

    const observer = new IntersectionObserver(([element]) => {
        if (element.intersectionRatio >= 0.85) {
            setHeaderDisplay('none')
            setHeaderTheme(HeaderTheme.TRANSPARENT_WHITE)
        } else {
            setHeaderDisplay('brand-logo')
            setHeaderTheme(HeaderTheme.WHITE)
        }
    }, { threshold: [1, 0.85, 0.1, 0] })

    observer.observe(heroContainer)
}

phoneStatementSlider()

// ------------------------------------------------------------------------------
//      Owning section
// ------------------------------------------------------------------------------

{
    new Swiper('.owning__swiper', {
        modules: [Pagination, Navigation, Autoplay],
        spaceBetween: 30,
        slidesPerView: 1,
        roundLengths: true,
        loop: true,
        speed: 500,
        autoplay: { delay: 5000, disableOnInteraction: false },
        loopAdditionalSlides: 2,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            [Breakpoint.MD]: {
                slidesPerView: 3,
            },
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
            renderBullet: (index: number, className: string) => `<span id="${index}" class="${className}"></span>`,
        },
    })
}
